const common: Record<string, Record<string, string> | string> = {
    responsibleExecutor: 'Ответственный исполнитель',
};

export default common;
